export const checkDuplicateFunds = (
  fundAgreementID,
  ticker,
  existingFundAgreements,
  selectedExistingAgreements
) => {
  // filter duplicate existing agreements based on the selected ticker
  const duplicateExistingAgreements = existingFundAgreements?.filter(
    agreement => {
      return selectedExistingAgreements?.some(
        selectedFund =>
          selectedFund?.ticker === agreement?.ticker &&
          selectedFund?.ticker === ticker
      );
    }
  );
  // returns false if there are no duplicate agreements
  if (duplicateExistingAgreements?.length <= 1) {
    return false;
  }
  // array which holds the selected agreement ids
  const selectedFundAgreements = selectedExistingAgreements?.map(
    ({ agreementID }) => agreementID
  );
  // returns false only if the agreement number is part of the selected agreement id
  return duplicateExistingAgreements?.some(
    () => !selectedFundAgreements.includes(fundAgreementID)
  );
};
